import { CreateWorkflowData, WorkflowData } from '@monorepo/interfaces';

export class LoadSelectedWorkflow {
    static readonly type = '[Workflow] Load Selected Workflow';
    constructor(public workflowId: string) {}
}

export class ClearSelectedWorkflow {
    static readonly type = '[Workflow] Clear Selected Workflow';
}

export class LoadMyWorkflows {
    static readonly type = '[Workflow] Load My Workflows';
}

export class CreateNewWorkflowData {
    static readonly type = '[Workflow] Create WorkflowData';
    constructor(public workflowData: CreateWorkflowData) {}
}

export class CreateNewWorkflowDataFromSapSearch {
    static readonly type = '[Workflow] Create WorkflowData From SAP Search';
    constructor(public workflowData: CreateWorkflowData) {}
}

export class PollSapSearchStatus {
    static readonly type = '[Workflow] Poll SAP Search Status';
    constructor(public processId: string) {}
}

export class ClearSapSearchProgress {
    static readonly type = '[Workflow] Clear SAP Search Progress';
}

export class LoadMyActiveTasks {
    static readonly type = '[Workflow] Load My Active Tasks';
    constructor(
        public page: number,
        public pageSize: number
    ) {}
}

export class LoadMyUrgentTasks {
    static readonly type = '[Workflow] Load My Urgent Tasks';
}

export class LoadMyFutureTasks {
    static readonly type = '[Workflow] Load My Future Tasks';
    constructor(
        public page: number,
        public pageSize: number
    ) {}
}
export class LoadMyPastTasks {
    static readonly type = '[Workflow] Load My Past Tasks';
    constructor(
        public page: number,
        public pageSize: number
    ) {}
}

export class LoadDashboardData {
    static readonly type = '[Workflow] Load Dashboard Data';
}

export class UpdateWorkflowData {
    static readonly type = '[Workflow] Update WorkflowData';
    constructor(public workflowData: WorkflowData) {}
}

export class PatchWorkflowData {
    static readonly type = '[Workflow] Patch WorkflowData';
    constructor(
        public workflowId: string,
        public body: Partial<WorkflowData>
    ) {}
}

export class SendWorkflowToNextStep {
    static readonly type = '[Workflow] Send Workflow to Next Step';
    constructor(
        public workflowId: string,
        public stepId: string,
        public bodyWithNextStep?: {
            nextStepId?: string;
            assignedTo?: string;
            validationJobId?: string;
        } | null
    ) {}
}

/**
 * Kicks off an async, parallel workflow validation job and polls its status
 * until terminal. Used in place of inline backend validation for large
 * workflows so the UI can render progress while validation runs.
 */
export class StartValidationJob {
    static readonly type = '[Workflow] Start Validation Job';
    constructor(public workflowId: string) {}
}

export class ClearValidationJob {
    static readonly type = '[Workflow] Clear Validation Job';
}

export class DownloadWorkflowCsv {
    static readonly type = '[Workflow] Download Workflow CSV';
    constructor(public workflowId: string) {}
}

export class LoadImportedWorkflowData {
    static readonly type = '[Workflow] Load Imported Workflow Data';
    constructor(public fileKey: string) {}
}

export class StartWorkflowDownload {
    static readonly type = '[Workflow] Start Workflow Download';
    constructor(public workflowId: string) {}
}

export class ClearWorkflowDownload {
    static readonly type = '[Workflow] Clear Workflow Download';
}
